import React, { Component } from 'react';

import './Blurb.css'

  export default class PanelBlurb extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>Thumbnail #1</h3>
                <p className='blurb-text'>Blurb #1</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PanelBlurb.jsx